import { z } from "zod";

const envsSchema = z.object({
  VITE_API_URL: z.string(),
  VITE_SITE_URL: z.string(),
  VITE_SITE_DOMAIN: z.string(),
  VITE_CAPTCHA_KEY: z.string(),
  VITE_PUSHER_KEY: z.string(),
  VITE_PUSHER_CLUSTER: z.string(),
  VITE_TLDRAW_WORKER_URL: z.string(),
  VITE_CRISP_ID: z.string(),
  VITE_STRIPE_PUBLISHABLE_KEY: z.string(),
  VITE_PUBLIC_POSTHOG_KEY: z.string(),
  VITE_PUBLIC_POSTHOG_HOST: z.string(),
});

const parsedEnvs = envsSchema.safeParse(import.meta.env);

if (!parsedEnvs.success) {
  console.error("Invalid environment variables: ", parsedEnvs.error.flatten());
  throw new Error("Invalid environment variables");
}

const envs = parsedEnvs.data;

export default envs;
